// extracted by mini-css-extract-plugin
export default {"sign-up":"SignUp_sign-up__ykMBV","center-box":"SignUp_center-box__A7q0K"};